import React from "react";
import { BrowserRouter } from "react-router-dom";
import "antd/dist/antd.min.css";
import Router from "./Router";
// import Menu1Page from "./pages/html/Menu1Page";
// import Menu2Page from "./pages/html/Menu2Page";
// import Menu3Page from "./pages/html/Menu3Page";
// import Menu4Page from "./pages/html/Menu4Page";
// import SectionPage from "./pages/uiTemplate/SectionPage2";
// import TitlePage from "./pages/uiTemplate/TitlePage";
// import GlobalClassPage from "./pages/uiTemplate/GlobalClassPage";
// import ReactExpressPage from "./pages/reactSample/ReactExpressPage";
// import CustomHooksPage from "./pages/reactSample/CustomHooksPage";
// import ReduxPage from "./pages/reactSample/ReduxPage";
// import NotFoundPage from "./pages/html/NotFoundPage";
// import Footer from "./components/Footer";
import GlobalStyles from "./GlobalStyles";
// import './App.css';
import { Amplify } from "aws-amplify";
import awsconfig from "./auth/awsconfig";
import { MqttProvider } from "./context/MqttContext";
import { startTokenRefreshScheduler } from "./api/client";
Amplify.configure(awsconfig);
startTokenRefreshScheduler();

// const { Content } = Layout;

function App() {
  return (
    <div className='body-container'>
      <GlobalStyles />
      <BrowserRouter>
        <MqttProvider>
          <Router />
        </MqttProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
